// extracted by mini-css-extract-plugin
export default {"formTitle":"create-exam-modal_formTitle__G3Zd-"};